import { css } from 'styled-components';
import token from 'styled-token';
import { StyledDialog } from '../../components/Dialog/Dialog.styles';
import { StyledMask } from '../../components/Mask/Mask.styles';
import { overflowAutoMixin } from '../overflowAutoMixin';

/** @class ModalMixin */
/** @method */
export var ModalMixin = function ModalMixin(props) {
  return token({
    boxShadow: 'Modal.boxShadow',
    paddingHorizontal: 'Modal.viewportPaddingHorizontal',
    paddingVertical: 'Modal.viewportPaddingVertical',
    zIndex: 'Modal.zIndex'
  }, function (_ref) {
    var boxShadow = _ref.boxShadow,
      paddingHorizontal = _ref.paddingHorizontal,
      paddingVertical = _ref.paddingVertical,
      zIndex = _ref.zIndex;
    return css(["position:fixed;top:0;left:0;z-index:", ";height:100%;width:100%;", " box-sizing:border-box;padding:", "px ", "px;> ", "{position:fixed;top:0;left:0;height:100%;width:100%;z-index:1;}display:flex;justify-content:center;align-items:center;> ", "", "{z-index:2;box-shadow:", ";}"], zIndex, overflowAutoMixin(props), paddingVertical, paddingHorizontal, StyledMask, StyledDialog, StyledDialog, boxShadow);
  })(props);
};